import { render, staticRenderFns } from "./AnswerAbcd.vue?vue&type=template&id=b2e6484c&"
import script from "./AnswerAbcd.vue?vue&type=script&lang=ts&"
export * from "./AnswerAbcd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports